import React, { JSX } from "react";

interface PrimaryTableProps {
  /** [Optional] Renders an additional row above the standard header row. Default true */
  columnGroupHeader?: boolean;
  /** [Optional] Renders custom column classes. Default 7 columns */
  customColumns?: string[];
  /** [Optional] Hides the table header. Default shown */
  hideHeader?: boolean;
  /** [Optional] The number of skeleton rows to render. Default 5 */
  rows?: number;
}

/**
 * Renders a skeleton table that is themed the same as our 'primary-table'
 * @param props
 */
function PrimaryTable(props: PrimaryTableProps): JSX.Element {
  const columnGroupHeader = props.columnGroupHeader !== false;
  const rows = props.rows || 5;

  const rowArray: JSX.Element[] = [];
  for (let i = 0; i < rows; i++) {
    rowArray.push(
      <div className="sk-row" key={i}>
        <div className="top-mask" />
        {props.customColumns ? (
          <React.Fragment>
            {props.customColumns.map((customColumn, index) => (
              <div className={customColumn} key={index} />
            ))}
          </React.Fragment>
        ) : (
            <React.Fragment>
              <div className="col-sep-mask-1" />
              <div className="col-sep-mask-2" />
              <div className="col-sep-mask-3" />
              <div className="col-sep-mask-4" />
              <div className="col-sep-mask-5" />
              <div className="col-sep-mask-6" />
              <div className="col-sep-mask-7" />
              <div className="col-sep-mask-8" />
          </React.Fragment>
        )}

        <div className="bottom-mask" />
      </div>);
  }

  return (
    <div className="primary-table-skeleton">
      {!props.hideHeader && (
        <div className="sk-head">
          {(columnGroupHeader || null) && (
            <div className="sk-row sk-group" />
          )}
          {rowArray[0]}
        </div>
      )}
      <div className="bone">
        {rowArray.map((r) => r)}
      </div>
    </div>
  );
}

export { PrimaryTable };
